module.exports = __webpack_public_path__ + "Wireframes2.png?953444f0e9500c2f70721d241f4bd3a3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Wireframes2.png
// module id = 116
// module chunks = 0